// 省略隐藏中间，目前只用于案号处理
function omitHide(el, options){
  // 获取当前文本内容
  const contentText = el.getAttribute('data-omit-hide-text') || el.innerText;
  if (!contentText) {
    return false;
  }
  el.innerText = contentText;
  const range = document.createRange();
  range.setStart(el, 0);
  range.setEnd(el, el.childNodes.length);
  const rangeRect = range.getBoundingClientRect();
  const cellRect = el.getBoundingClientRect();
  if (rangeRect.width > cellRect.width) {
    // 更新替换的内容
    const regStr = `^(.{${options.s}})(.*)(.{${options.e}})$`;
    const reg = new RegExp(regStr);
    el.innerText = contentText.replace(reg, `$1${options.r}$3`);
  }
}
export default {
  bind(el, binding, vNode) {
    const options = {
      s: 5,
      e: 6,
      r: '***'
    }
    const {
      value
    } = binding;
    // 更新设置
    if (value) {
      Object.keys(value).forEach(key => {
        options[key] = value[key];
      })
    }
    el.__omitHideOptoin__ = options;
  },
  inserted(el, binding, vNode) {
    const options = el.__omitHideOptoin__;
    // 判断文本内容是否超出
    omitHide(el, options);
  },
  update(el, binding, vNode) {
    const options = el.__omitHideOptoin__;
    // 判断文本内容是否超出
    omitHide(el, options);
  },
  unbind(el, binding) {
    delete el.__omitHideOptoin__;
  }
}
